export type ButtonVariant = 'primary' | 'dark' | 'outline' | 'outline-light' | 'ghost' | 'ghost-light';
export type ButtonSize = 'sm' | 'md' | 'lg';

const base =
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-display font-semibold tracking-tight transition-[background-color,color,border-color,transform] duration-150 ease-out active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60';

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-copper text-white hover:bg-copper-deep',
  dark: 'bg-aubergine text-porcelain hover:bg-aubergine-600',
  outline: 'border border-plum/20 text-plum hover:border-copper hover:text-copper-deep',
  'outline-light': 'border border-porcelain/35 text-porcelain hover:border-copper-light hover:text-copper-light',
  ghost: 'px-0 text-copper-deep hover:text-plum',
  'ghost-light': 'px-0 text-copper-light hover:text-porcelain',
};

const sizes: Record<ButtonSize, string> = {
  sm: 'h-10 px-5 text-sm',
  md: 'h-12 px-6 text-[15px]',
  lg: 'h-14 px-8 text-base',
};

export function buttonClasses(variant: ButtonVariant = 'primary', size: ButtonSize = 'md', extra = ''): string {
  const sizeClass = variant.startsWith('ghost') ? sizes[size].replace(/px-\d+/, '') : sizes[size];
  return [base, variants[variant], sizeClass, extra].filter(Boolean).join(' ');
}
